module.exports = __webpack_public_path__ + "static/img/yimi.b8d24004.jpg";